import React from 'react'

// label: text/content rendered next to the node
// nodeColor: color of the circular dot marker
// edgeColor: color of the connecting line to the next node; pass falsy to hide the line even when not last
// textClass: className applied to the label span
// isLast: when true, omits the connecting line and bottom padding (this is the final node in the timeline)
// gap: vertical spacing before the next node; ignored when isLast (defaults to 20)
export default function TimelineNode({ label, nodeColor, edgeColor, textClass, isLast, gap = 20 }) {
  return (
    <div className="dome-d-flex dome-gap6">
      <div style={{ flexShrink: 0, width: 20 }} className="dome-d-flex dome-flex-column dome-align-center">
        <i style={{ fontSize: 8, color: nodeColor, zIndex: 1 }} className="fa-solid fa-circle" />
        {!isLast && edgeColor && (
          <div
            style={{
              width: 1,
              flexGrow: 1,
              minHeight: 8,
              marginTop: -1,
              background: edgeColor,
            }}
          />
        )}
      </div>
      <span className={textClass} style={{ marginTop: -4.5, paddingBottom: isLast ? 0 : gap }}>
        {label}
      </span>
    </div>
  )
}
